function parseNumber(rawValue) {
    let number = parseFloat(rawValue)

    return isNumeric(number) ? number : null
}

function isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject)
}

const formatters = {}

const factory = (locale, options) => {
    const key = `${locale}.${JSON.stringify(options)}`
    if (!formatters[key]) {
        formatters[key] = new Intl.NumberFormat(locale, options)
    }

    return formatters[key]
}

export default function (Alpine) {
    Alpine.magic("currency", function ($el, Alpine) {
        return (value, decimal = 2, currency = "EUR", locale = "fr-FR") =>
            factory(locale, {
                style: "currency",
                currency,
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
            }).format(value)
    })

    Alpine.magic("minorCurrency", function ($el, Alpine) {
        return (value, decimal = 2, currency = "EUR", locale = "fr-FR") =>
            factory(locale, {
                style: "currency",
                currency,
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
            }).format(value / 100)
    })

    Alpine.magic("number", function () {
        return (value) => parseNumber(value)
    })

    Alpine.magic("bool", function () {
        return (value) =>
            typeof value === "boolean"
                ? value
                : value === true || Boolean(value * 1)
    })
}
